// Where each letter's ink sits in IBM Plex Mono SemiBold (the star glyphs'
// face), so a letter can be centred in its disc on its own shape rather than
// on the cap or x-height: d, t, h, l reach above the x-height, g, p, y below.
// Measured in the browser with canvas measureText (actualBoundingBoxAscent and
// Descent at 1000 px), in thousandths of an em: [above the baseline, below it].
const INK: Record<string, readonly [number, number]> = {
  A: [698, 0], B: [698, 0], C: [710, 12], D: [698, 0], E: [698, 0], F: [698, 0], G: [710, 12],
  H: [698, 0], I: [698, 0], J: [698, 12], K: [698, 0], L: [698, 0], M: [698, 0], N: [698, 0],
  O: [710, 12], P: [698, 0], Q: [710, 183], R: [698, 0], S: [710, 12], T: [698, 0], U: [698, 12],
  V: [698, 0], W: [698, 0], X: [698, 0], Y: [698, 0], Z: [698, 0],
  a: [528, 12], b: [740, 12], c: [528, 12], d: [740, 12], e: [528, 12], f: [740, 0], g: [606, 212],
  h: [740, 0], i: [750, 0], j: [750, 200], k: [740, 0], l: [740, 0], m: [528, 0], n: [528, 0],
  o: [528, 12], p: [528, 200], q: [528, 200], r: [516, 0], s: [528, 12], t: [698, 0], u: [516, 12],
  v: [516, 0], w: [516, 0], x: [516, 0], y: [516, 200], z: [516, 0],
  Ä: [907, 0], Ö: [907, 12], Ü: [907, 12], ä: [737, 12], ö: [737, 12], ü: [737, 12], ß: [740, 200],
};

/** IBM Plex Mono's cap height (698/1000 em), for anything not in the table. */
export const CAP_HEIGHT = 0.698;

/**
 * How far below a glyph's centre its baseline goes, in ems, so the ink's middle
 * lands on the centre. Text not in the table (2L, 3W) centres on the cap height.
 */
export function baselineDrop(text: string): number {
  const ink = INK[text];
  return ink ? (ink[0] - ink[1]) / 2000 : CAP_HEIGHT / 2;
}
